import React from 'react';
import Trans from 'next-translate/Trans';
import { CodeClipboard } from '@dotone/react-ui-core';

const Clipboard = (props) => <CodeClipboard className="pb-2" language="html" {...props} />;

const DocsTranslate = ({
  tKey,
  components,
  code,
  gtmImages = [],
  clipboardProps,
  ...otherProps
}) => {
  const imageComponents = {};
  gtmImages.forEach((imgSrc, index) => {
    const key = `gtmImage${index + 1}`;
    imageComponents[key] = <img src={imgSrc} alt={`gtm-${index + 1}`} {...otherProps} />;
  });

  return (
    <Trans
      i18nKey={`docs:${tKey}`}
      components={{
        h5: <h5 className="text-dark-light" />,
        li: <li />,
        ol: <ol />,
        ul: <ul />,
        strong: <strong />,
        em: <em />,
        p: <p className="m-0" />,
        code: <Clipboard value={code} {...clipboardProps} />,
        ...imageComponents,
        ...components,
      }}
      {...otherProps}
    />
  );
};

export default DocsTranslate;
